import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from './constants';

export const useServiceConfigurationStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: COLORS.bgPage,
    minHeight: 480,
  },
  title: {
    fontWeight: 700,
    color: COLORS.body,
    marginBottom: theme.spacing(0.5),
  },
  subtitle: {
    color: COLORS.muted,
    marginBottom: theme.spacing(2),
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  searchField: {
    maxWidth: 360,
    flex: 1,
  },
  searchIcon: {
    color: COLORS.muted,
  },
  spacer: {
    flex: 1,
  },
  tableWrap: {
    backgroundColor: COLORS.cardBg,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${COLORS.border}`,
  },
  empty: {
    color: COLORS.muted,
    padding: theme.spacing(3),
    textAlign: 'center',
  },
  inactiveChip: {
    color: COLORS.muted,
  },
}));
